import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SUBSCRIPTION_DATA } from "../sagaTypes";
import { loaderAction,
    subscriptionCoachesAction,
    subscriptionConstrainsAction,
    subscriptionDurationsAction,
    subscriptionTypesAction,
    subscriptionWorkoutsCountAction,
    paymentMethodsAction,
    discountAction,
    adminsAction,
    startApp
} from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_subscription_data`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSubscriptionData() {
    const user = yield select(state => state.user);
    const establishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('establishment', establishment);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(subscriptionCoachesAction(response.coaches));
            yield put(subscriptionTypesAction(response.types));
            yield put(subscriptionDurationsAction(response.duration));
            yield put(subscriptionConstrainsAction(response.constraints));
            yield put(subscriptionWorkoutsCountAction(response.workouts_count));
            yield put(paymentMethodsAction(response.payment_methods));
            yield put(discountAction(response.discount));
            yield put(adminsAction(response.admins));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
        yield put(startApp());
    }
}

export default function* watcherGetSubscriptionData() {
    yield takeLatest(GET_SUBSCRIPTION_DATA, workerGetSubscriptionData);
}